import { render, staticRenderFns } from "./changePhone.vue?vue&type=template&id=1139f42d&scoped=true&"
import script from "./changePhone.vue?vue&type=script&lang=js&"
export * from "./changePhone.vue?vue&type=script&lang=js&"
import style0 from "./changePhone.vue?vue&type=style&index=0&id=1139f42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139f42d",
  null
  
)

export default component.exports